
/**
 * 404エラーページ
 * 存在しないページにアクセスした際の表示コンポーネント
 */

import { Link } from 'react-router-dom'
import { Button } from '@/shared/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'
import { Home, ArrowLeft } from 'lucide-react'

/**
 * 404エラーページコンポーネント
 */
export default function NotFound() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background px-4">
            <Card className="w-full max-w-md">
                <CardHeader className="text-center">
                    <CardTitle className="text-6xl font-bold text-muted-foreground mb-4">
                        404
                    </CardTitle>
                    <h1 className="text-2xl font-semibold text-foreground">
                        ページが見つかりません
                    </h1>
                </CardHeader>
                <CardContent className="text-center space-y-4">
                    <p className="text-muted-foreground">
                        お探しのページは存在しないか、移動された可能性があります。
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <Button asChild variant="default">
                            <Link to="/">
                                <Home className="mr-2 h-4 w-4" />
                                ホームに戻る
                            </Link>
                        </Button>
                        <Button asChild variant="outline" onClick={() => window.history.back()}>
                            <span className="cursor-pointer">
                                <ArrowLeft className="mr-2 h-4 w-4" />
                                前のページに戻る
                            </span>
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    )
} 